module.exports = __webpack_public_path__ + "media/Audio15_n.1af92cdf.wav";